//const API_BASE_URL = 'https://server.good-jabi.com/'
const API_BASE_URL = 'https://server.leewonwook.com/'

export { API_BASE_URL }
